<template>
  <v-app>
    <dashboard-core-app-bar v-model="expandOnHover" />

    <dashboard-core-drawer :expand-on-hover.sync="expandOnHover" />

    <dashboard-core-view />

    <dashboard-core-settings v-model="expandOnHover" />
    <group-bulk-sms-composer />
    <group-bulk-email-composer />
    <group-bulk-ivr-composer />
    <patient-details-viewer />
  </v-app>
</template>

<script>
  /* eslint-disable */
import PatientDetailsViewer from "../../modules/private-module/components/patient-details-viewer/patient-details-viewer.vue";
import UserHelper from "../../utils/user-helper";

export default {
  name: "DashboardIndex",

  components: {
    DashboardCoreAppBar: () => import("./components/core/AppBar"),
    DashboardCoreDrawer: () => import("./components/core/Drawer"),
    DashboardCoreSettings: () => import("./components/core/Settings"),
    DashboardCoreView: () => import("./components/core/View"),
    GroupBulkSmsComposer: () => import(
        "../../modules/private-module/components/group-bulk-sms-composer/group-bulk-sms-composer.vue"
      ),
    GroupBulkEmailComposer: () => import(
        "../../modules/private-module/components/group-bulk-email-composer/group-bulk-email-composer.vue"
      ),
    GroupBulkIvrComposer: () => import(
        "../../modules/private-module/components/group-bulk-ivr-composer/group-bulk-ivr-composer.vue"
      ),
    PatientDetailsViewer
  },

  data: () => ({
    expandOnHover: false
  }),
  created () {
    UserHelper.syncUserInfo();
  }
};
</script>
